import { render } from "./TrackProducts.vue?vue&type=template&id=318284da&scoped=true"
const script = {}

import "./TrackProducts.vue?vue&type=style&index=0&id=318284da&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318284da"]])

export default __exports__